import { QueryFunctionContext } from '@tanstack/react-query'
import anklePatrolAxios from '../../../services/config/axiosClient'
import { mobileContactApiRoutes } from './apiRoutes'

export const ticketList = ({ queryKey }: QueryFunctionContext) =>
  anklePatrolAxios.get(
    `${mobileContactApiRoutes.ticketList}?limit=${queryKey?.[2]}&page=${queryKey?.[1]}`,
  )

export const closeTicket = (payload: { ticketId: string | undefined }) =>
  anklePatrolAxios.put(mobileContactApiRoutes.closeTicket, payload)
